import { useEffect, useState } from 'react';
import { realtime } from '../realtime';

/** Не мигаем индикатором при коротком переподключении: «нет связи» показываем, только если оно длится дольше. */
const SHOW_DELAY_MS = 1500;

/**
 * «Всё в порядке»: WS подключён и догоняющая сверка (/sync) после переподключения завершена.
 * false — UI показывает «Соединение…» / «Обновление…» (ConnectingBadge) вместо обычного статуса.
 * Переход в false откладывается на SHOW_DELAY_MS, обратно в true — сразу.
 */
export function useConnectionStatus(): boolean {
  const [ok, setOk] = useState(() => realtime.isConnected() && !realtime.isSyncing());
  useEffect(() => {
    let timer: number | undefined;
    const apply = () => {
      window.clearTimeout(timer);
      if (realtime.isConnected() && !realtime.isSyncing()) setOk(true);
      else timer = window.setTimeout(() => setOk(false), SHOW_DELAY_MS);
    };
    apply();
    const off1 = realtime.onStatus(apply);
    const off2 = realtime.onSyncing(apply);
    return () => {
      window.clearTimeout(timer);
      off1();
      off2();
    };
  }, []);
  return ok;
}

/** true, пока идёт догоняющая сверка (подключение уже есть) — подпись «Обновление…» вместо «Соединение…». */
export function useSyncing(): boolean {
  const [syncing, setSyncing] = useState(() => realtime.isSyncing());
  useEffect(() => realtime.onSyncing(setSyncing), []);
  return syncing;
}
